/* eslint-disable eqeqeq */
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getIncidentDetail } from "./IncidentHelper";
import {
  amlctfIndictorOptions,
  API,
  bniIndicatorOptions,
  bniTypeOptions,
  fileUpload,
  incidentMovementTypeOptions,
  incidentPaymentMethodOptions,
  incidentTransactionType,
  incidentTypeOptions,
  suspicionTypeOptions,
} from "../../../config";
// import Spin from "../../../components/Spin";
import { Button } from "../../../components/ui/button";
import Spin from "../../../components/Spin";
import { useOrganization } from "../../../lib/context/OrganisationContext";
import {
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../../lib/Misc";
import { Label } from "../../../components/ui/label";
import CustomLabelText from "../../../components/CustomLabelText";
import { Textarea } from "../../../components/ui/textarea";
import * as Yup from "yup";
import { Input } from "../../../components/ui/input";
import SearchSelect from "../../../components/SearchSelect";
import { AlertCircle, FileText, Globe, Landmark, Loader2 } from "lucide-react";
import { Separator } from "../../../components/ui/separator";
import { DateInputPicker } from "../../../components/DateInputPicker";
import ContactSelect from "../../../components/ContactSelect";
import VendorSelect from "../../../components/VendorSelect";
import TrustSelect from "../../../components/TrustSelect";
import UserSelect from "../../../components/UserSelect";
import { useCountryList } from "../../../lib/OptionsAPI";
import AssetSelect from "../../../components/AssetSelect";
import SubAssetSelect from "../../../components/SubAssetSelect";
import MultiFileUpload from "../../../components/MultiFileUpload";
import moment from "moment";
import { MultiSelect } from "../../../components/SearchMultiSelect";
// import moment from "moment";

const AddEditIncident = ({
  edit,
  incidentID,
  toggleShowAddEditIncident,
  editByIncident = false,
  fetchIncidents,
}) => {
  const { id } = useParams();
  // eslint-disable-next-line no-unused-vars
  // const [incidentData, setIncidentData] = useState();
  const [files, setFiles] = useState();

  const { organizationData } = useOrganization();

  const [userLoading, setUserLoading] = useState(false);
  const [userListing, setUserListing] = useState([]);
  const [userList, setUserList] = useState([]);

  const [vendorLoading, setVendorLoading] = useState(false);
  const [vendorListing, setVendorListing] = useState([]);
  const [vendorList, setVendorList] = useState([]);

  const [contactLoading, setContactLoading] = useState(false);
  const [contactListing, setContactListing] = useState([]);
  const [contactList, setContactList] = useState([]);

  const [trustLoading, setTrustLoading] = useState(false);
  const [trustListing, setTrustListing] = useState([]);
  const [trustList, setTrustList] = useState([]);

  const [assetLoading, setAssetLoading] = useState(false);
  const [assetListing, setAssetListing] = useState([]);
  const [assetList, setAssetList] = useState([]);

  const [subAssetLoading, setSubAssetLoading] = useState(false);
  const [subAssetListing, setSubAssetListing] = useState([]);
  const [subAssetList, setSubAssetList] = useState([]);

  const { countryLoading, countryList = [] } = useCountryList();
  const countryListing = countryList?.map((item) => {
    const { id: value, name, short_name, ...rest } = item;
    return { label: name + ` (${short_name})`, value, ...rest };
  });

  const currencyListing = countryList?.map((item) => {
    const { short_name: value, name, currency, short_name, ...rest } = item;
    return { label: name + ` (${currency})`, value, ...rest };
  });
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);

  /* =========================================================
  Initial Values
========================================================= */

  let initialValues = {
    // Common
    incident_type: "",
    contactable_type: "",
    trust_id: "",
    contactable_id: "",
    incident_date: "",
    review_by_id: "",
    review_date: "",
    asset_id: "",
    sub_asset_id: "",
    note: "",

    // SMR
    suspicion_type: "",
    aml_ctf_indicator: "",
    activity_date_from: "",
    activity_date_to: "",
    smr_amount: "",
    smr_currency: "AUS",
    countries_involved: "",
    grounds_for_suspicion: "",
    investigation_summary: "",
    customer_explanation: "",
    previous_smr_reference: "",

    // TTR
    transactor_name: "",
    transactor_id: "",
    transaction_date: "",
    amount: "",
    currency: "AUS",
    aud_equivalent: "",
    transaction_type: "",
    product_service: "",
    account_number: "",
    branch_location: "",
    transaction_purpose: "",

    // IFTI
    ordering_party_name: "",
    ordering_party_account: "",
    beneficiary_name: "",
    beneficiary_account: "",
    transfer_date: "",
    // amount: "",
    // currency: "AUS",
    // aud_equivalent: "",
    origin_country: "",
    destination_country: "",
    sending_institution: "",
    receiving_institution: "",
    intermediary_institution: "",
    payment_method: "",
    payment_reference: "",

    // CBM
    movement_type: "",
    movement_date: "",
    border_port: "",
    // origin_country: "",
    // destination_country: "",
    // amount: "",
    // currency: "AUS",
    // aud_equivalent: "",
    bni_indicator: "",
    bni_type: "",
    bni_number: "",
    bni_issuer: "",
    bni_value: "",
    bni_currency: "AUS",
    funds_purpose: "",
    funds_owner: "",
  };

  const [incidentData, setIncidentData] = useState(initialValues);

  useEffect(() => {
    if (assetList) {
      let assetTempListing = assetList?.map((item) => ({
        ...item,
        value: item?.id,
        label: item?.name
          ? `${item.name}${item?.code ? ` (${item?.code})` : ""}`
          : "",
      }));
      setAssetListing(assetTempListing || []);
    } else {
      setAssetListing([]);
    }
  }, [assetList]);

  useEffect(() => {
    if (subAssetList) {
      let subAssetTempListing = subAssetList?.map((item) => ({
        ...item,
        value: item?.id,
        label: item?.name
          ? `${item.name}${item?.identifier ? ` (${item?.identifier})` : ""}`
          : "",
      }));
      setSubAssetListing(subAssetTempListing || []);
    } else {
      setSubAssetListing([]);
    }
  }, [subAssetList]);

  const contactTypeOption = [
    {
      label: `${getModuleNamingBySlug(
        organizationData?.organizationData,
        "vendors",
        "Vendor",
      )}`,
      value: 1,
    },
    {
      label: `${getModuleNamingBySlug(
        organizationData?.organizationData,
        "contacts",
        "Customer",
      )}`,
      value: 2,
    },
  ];

  const incidentId = incidentID ? incidentID : id;
  // const formValues = useRef();

  async function fetchData() {
    try {
      setLoading(true);
      const data = await getIncidentDetail(incidentId);
      setFiles(data?.files);
      initialValues = {
        // Common
        incident_type: data?.incident_type ? data?.incident_type : "",
        contactable_type: data?.contactable_type === "vendor" ? 1 : 2,
        trust_id: data?.trust_id ? data?.trust_id : "",
        contactable_id: data?.contactable_id ? data?.contactable_id : "",
        incident_date: data?.incident_date
          ? moment(data?.incident_date, "DD-MM-YYYY")
          : "",
        review_by_id: data?.review_by_id ? data?.review_by_id : "",
        review_date: data?.review_date ? data?.review_date : "",
        asset_id: data?.asset_id ? data?.asset_id : "",
        sub_asset_id: data?.sub_asset_id ? data?.sub_asset_id : "",
        note: data?.note ? data?.note : "",

        // SMR
        suspicion_type: data?.details?.suspicion_type
          ? data?.details?.suspicion_type
          : "",
        aml_ctf_indicator: data?.details?.aml_ctf_indicator
          ? data?.details?.aml_ctf_indicator
          : "",
        activity_date_from: data?.details?.activity_date_from
          ? moment(data?.details?.activity_date_from, "DD-MM-YYYY")
          : "",
        activity_date_to: data?.details?.activity_date_to
          ? moment(data?.details?.activity_date_to, "DD-MM-YYYY")
          : "",
        smr_amount: data?.details?.smr_amount ? data?.details?.smr_amount : "",
        smr_currency: data?.details?.smr_currency
          ? data?.details?.smr_currency
          : "AUS",
        countries_involved: data?.details?.countries_involved
          ? data?.details?.countries_involved?.split(",")
          : "",
        grounds_for_suspicion: data?.details?.grounds_for_suspicion
          ? data?.details?.grounds_for_suspicion
          : "",
        investigation_summary: data?.details?.investigation_summary
          ? data?.details?.investigation_summary
          : "",
        customer_explanation: data?.details?.customer_explanation
          ? data?.details?.customer_explanation
          : "",
        previous_smr_reference: data?.details?.previous_smr_reference
          ? data?.details?.previous_smr_reference
          : "",

        // TTR
        transactor_name: data?.details?.transactor_name
          ? data?.details?.transactor_name
          : "",
        transactor_id: data?.details?.transactor_id
          ? data?.details?.transactor_id
          : "",
        transaction_date: data?.details?.transaction_date
          ? moment(data?.details?.transaction_date, "DD-MM-YYYY")
          : "",
        amount: data?.details?.amount ? data?.details?.amount : "",
        currency: data?.details?.currency ? data?.details?.currency : "AUS",
        aud_equivalent: data?.details?.aud_equivalent
          ? data?.details?.aud_equivalent
          : "",
        transaction_type: data?.details?.transaction_type
          ? data?.details?.transaction_type
          : "",
        product_service: data?.details?.product_service
          ? data?.details?.product_service
          : "",
        account_number: data?.details?.account_number
          ? data?.details?.account_number
          : "",
        branch_location: data?.details?.branch_location
          ? data?.details?.branch_location
          : "",
        transaction_purpose: data?.details?.transaction_purpose
          ? data?.details?.transaction_purpose
          : "",

        // IFTI
        ordering_party_name: data?.details?.ordering_party_name
          ? data?.details?.ordering_party_name
          : "",
        ordering_party_account: data?.details?.ordering_party_account
          ? data?.details?.ordering_party_account
          : "",
        beneficiary_name: data?.details?.beneficiary_name
          ? data?.details?.beneficiary_name
          : "",
        beneficiary_account: data?.details?.beneficiary_account
          ? data?.details?.beneficiary_account
          : "",
        transfer_date: data?.details?.transfer_date
          ? moment(data?.details?.transfer_date, "DD-MM-YYYY")
          : "",
        origin_country: data?.details?.origin_country
          ? data?.details?.origin_country
          : "",
        destination_country: data?.details?.destination_country
          ? data?.details?.destination_country
          : "",
        sending_institution: data?.details?.sending_institution
          ? data?.details?.sending_institution
          : "",
        receiving_institution: data?.details?.receiving_institution
          ? data?.details?.receiving_institution
          : "",
        intermediary_institution: data?.details?.intermediary_institution
          ? data?.details?.intermediary_institution
          : "",
        payment_method: data?.details?.payment_method
          ? data?.details?.payment_method
          : "",
        payment_reference: data?.details?.payment_reference
          ? data?.details?.payment_reference
          : "",

        // CBM
        movement_type: data?.details?.movement_type
          ? data?.details?.movement_type
          : "",
        movement_date: data?.details?.movement_date
          ? moment(data?.details?.movement_date, "DD-MM-YYYY")
          : "",
        border_port: data?.details?.border_port
          ? data?.details?.border_port
          : "",
        bni_indicator: data?.details?.bni_indicator
          ? data?.details?.bni_indicator
          : "",
        bni_type: data?.details?.bni_type ? data?.details?.bni_type : "",
        bni_number: data?.details?.bni_number ? data?.details?.bni_number : "",
        bni_issuer: data?.details?.bni_issuer ? data?.details?.bni_issuer : "",
        bni_value: data?.details?.bni_value ? data?.details?.bni_value : "",
        bni_currency: data?.details?.bni_currency
          ? data?.details?.bni_currency
          : "AUS",
        funds_purpose: data?.details?.funds_purpose
          ? data?.details?.funds_purpose
          : "",
        funds_owner: data?.details?.funds_owner ? data?.funds_owner : "",
      };

      setIncidentData(initialValues);
      setLoading(false);
    } catch (e) {
      setIncidentData(null);
    }
  }

  useEffect(() => {
    if (edit) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [incidentId]);

  useEffect(() => {
    if (userList) {
      let userTempListing = userList?.map((item) => ({
        ...item,
        value: item?.id,
        label: formatSubcontractorName(item),
      }));
      setUserListing(userTempListing || []);
    } else {
      setUserListing([]);
    }
  }, [userList]);

  useEffect(() => {
    if (trustList) {
      let trustTempListing = trustList?.map((item) => ({
        ...item,
        value: item?.id,
        label: item?.business_name
          ? item?.business_name
          : item?.first_name
            ? item?.first_name + " " + item?.last_name
            : item?.last_name,
      }));
      setTrustListing(
        trustTempListing?.filter((item) => item.value !== "new") || [],
      );
    } else {
      setTrustListing([]);
    }
  }, [trustList]);

  useEffect(() => {
    if (vendorList) {
      let vendorTempListing = vendorList?.map((item) => ({
        ...item,
        value: item?.id,
        label: `${formatSubcontractorName(item)}${
          item?.code ? ` (${item?.code})` : ""
        }`,
      }));
      setVendorListing(vendorTempListing || []);
    } else {
      setVendorListing([]);
    }
  }, [vendorList]);

  useEffect(() => {
    if (contactList) {
      let contactTempListing = contactList?.map((item) => ({
        ...item,
        value: item.id,
        label: `${formatSubcontractorName(item)}${
          item?.code ? ` (${item?.code})` : ""
        }`,
      }));
      setContactListing(contactTempListing || []);
    } else {
      setContactListing([]);
    }
  }, [contactList]);

  // Submit Form
  const handleFormSubmit = async (value) => {
    const formData = new FormData();

    value.amount = Number(`${value?.amount}`.replace(/,/g, ""));

    if (files?.length > 0) {
      for (let fileIndex = 0; fileIndex < files?.length; fileIndex++) {
        if (files[fileIndex]?.id) {
          formData.append(`file_ids[${fileIndex}]`, files[fileIndex]?.id);
        }
        formData.append(
          `files[${fileIndex}]`,
          files[fileIndex]?.url
            ? files[fileIndex]?.url
            : files[fileIndex]?.file,
        );
      }
    }

    console.log(value);

    formData.append(
      "organization_id",
      organizationData?.organizationId ? organizationData?.organizationId : "",
    );

    Object.keys(value).forEach((key) => {
      let fieldValue = value[key];

      if (fieldValue instanceof Date || moment.isMoment(fieldValue)) {
        fieldValue = moment(fieldValue).format("DD-MM-YYYY");
      }

      if (
        key === "incident_type" ||
        key === "contactable_type" ||
        key === "trust_id" ||
        key === "contactable_id" ||
        key === "incident_date" ||
        key === "asset_id" ||
        key === "sub_asset_id" ||
        key === "review_by_id" ||
        key === "review_date" ||
        key === "note"
      ) {
        formData.append(key, fieldValue ?? "");
      } else if (key?.includes("currency")) {
        formData.append(`details[${key}]`, fieldValue ?? "AUS");
      } else {
        formData.append(`details[${key}]`, fieldValue ?? "");
      }
    });

    if (incidentId) {
      formData.append("_method", "put");
    }
    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.INCIDENT_ADD}${incidentId ? `/${incidentId}` : ""}`,
        formData,
      );
      setLoading(false);
      if (data) {
        editByIncident &&
          localStorage.setItem(
            "BusinessName",
            value?.business_name ? value?.business_name : "",
          );
        toggleShowAddEditIncident();
        fetchIncidents && fetchIncidents();
      }
      return data?.data;
    } catch (error) {
      setIncidentData(null);
      setLoading(false);
    }
  };

  /* =========================================================
  Validation
========================================================= */

  const required = (message = "This field is required") =>
    Yup.string().trim().required(message);

  const getValidationSchema = (values) => {
    let schema = {
      incident_type: Yup.string().required("Incident Type is required"),
      contactable_type: Yup.number()
        .required("Contact type is required.")
        .nullable(),

      contactable_id: Yup.string().when("contactable_type", {
        is: 1,
        then: (schema) =>
          schema
            .required(
              `${getModuleNamingBySlug(
                organizationData?.organizationData,
                "vendors",
                "Vendor",
              )} is required.`,
            )
            .nullable(),
        otherwise: (schema) =>
          schema.when("contactable_type", {
            is: 2,
            then: (s) =>
              s
                .required(
                  `${getModuleNamingBySlug(
                    organizationData?.organizationData,
                    "contacts",
                    "Customer",
                  )} is required.`,
                )
                .nullable(),
            otherwise: (s) =>
              s.required("Contact type is required.").nullable(),
          }),
      }),
      // priority: required("Priority is required"),
      incident_date: required("Incident date is required"),
    };

    /* =========================
     SMR
  ========================= */

    if (values.incident_type === "0") {
      schema = {
        ...schema,

        suspicion_type: required(),
        aml_ctf_indicator: required(),
        activity_date_from: required(),
        grounds_for_suspicion: Yup.string()
          .trim()
          .required("Grounds for suspicion are required"),
        investigation_summary: required(),
        smr_currency: required(),
      };
    }

    /* =========================
     TTR
  ========================= */

    if (values.incident_type === "1") {
      schema = {
        ...schema,

        transaction_date: required(),

        amount: Yup.number()
          .typeError("Enter a valid amount")
          .positive("Amount must be greater than zero")
          .required("Cash amount is required"),

        currency: required(),

        aud_equivalent: Yup.number()
          .typeError("Enter a valid AUD equivalent")
          .positive("AUD equivalent must be greater than zero")
          .required("AUD equivalent is required"),

        transaction_type: required(),
      };
    }

    /* =========================
     IFTI
  ========================= */

    if (values.incident_type === "2") {
      schema = {
        ...schema,

        ordering_party_name: required(),
        beneficiary_name: required(),
        transfer_date: required(),

        amount: Yup.number()
          .typeError("Enter a valid amount")
          .positive("Amount must be greater than zero")
          .required("Transfer amount is required"),

        currency: required(),

        aud_equivalent: Yup.number()
          .typeError("Enter a valid AUD equivalent")
          .positive("AUD equivalent must be greater than zero")
          .required("AUD equivalent is required"),

        origin_country: required(),
        destination_country: required(),
        sending_institution: required(),
        receiving_institution: required(),
        payment_method: required(),
      };
    }

    /* =========================
     CBM
  ========================= */

    if (values.incident_type === "3") {
      schema = {
        ...schema,
        movement_type: required(),
        movement_date: required(),
        border_port: required(),
        origin_country: required(),
        destination_country: required(),

        amount: Yup.number()
          .typeError("Enter a valid amount")
          .positive("Amount must be greater than zero")
          .required("Amount is required"),

        currency: required(),

        aud_equivalent: Yup.number()
          .typeError("Enter a valid AUD equivalent")
          .positive("AUD equivalent must be greater than zero")
          .required("AUD equivalent is required"),

        bni_indicator: required(),
      };
    }

    return Yup.object(schema);
  };

  /* =========================================================
  Form Field
========================================================= */

  const FormField = ({
    label,
    name,
    formik,
    type = "text",
    placeholder,
    required: isRequired = false,
    className = "",
  }) => {
    const error =
      formik.touched[name] && formik.errors[name] ? formik.errors[name] : "";

    return (
      <div className="grid gap-2">
        <Label htmlFor={name}>
          <CustomLabelText
            required={isRequired}
            labelText={label}
            errorField={error}
          />
        </Label>
        <Input
          id={name}
          name={name}
          value={formik.values[name]}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          placeholder={placeholder}
          autoComplete="off"
          onKeyPress={(e) => {
            e.which === 13 && e.preventDefault();
          }}
          className={error && `focus-visible:ring-red-500 border-red-500`}
        />
      </div>
    );
  };

  /* =========================================================
  Select Field
========================================================= */

  const FormSelect = ({
    label,
    name,
    formik,
    options,
    loading = false,
    required: isRequired = false,
  }) => {
    const error =
      formik.touched[name] && formik.errors[name] ? formik.errors[name] : "";

    return (
      <div className="grid gap-2">
        <div className="min-w-0">
          <Label htmlFor={name}>
            <CustomLabelText
              required={isRequired}
              labelText={label}
              errorField={error}
            />
          </Label>
          <div className="relative mt-2">
            <SearchSelect
              frameworks={options}
              optionType={label}
              handleSelect={(e) => {
                formik.setFieldValue(name, e);
              }}
              handleBlur={formik.handleBlur}
              className={error && `focus-visible:ring-red-500 border-red-500`}
              disabled={loading}
              initialValue={formik.values[name]}
            />
          </div>
        </div>
      </div>
    );
  };

  /* =========================================================
  Multi Select Field
========================================================= */

  const FormMultiSelect = ({
    label,
    name,
    formik,
    options,
    loading = false,
    required: isRequired = false,
  }) => {
    const error =
      formik.touched[name] && formik.errors[name] ? formik.errors[name] : "";

    return (
      <div className="grid gap-2">
        <div className="min-w-0">
          <Label htmlFor={name}>
            <CustomLabelText
              required={isRequired}
              labelText={label}
              errorField={error}
            />
          </Label>
          <div className="relative mt-2">
            <MultiSelect
              options={options}
              placeholder={label}
              onValueChange={(e) => {
                formik.setFieldValue(name, e);
              }}
              handleBlur={formik.handleBlur}
              className={error && `focus-visible:ring-red-500 border-red-500`}
              disabled={loading}
              defaultValue={formik.values[name]}
              variant="inverted"
              animation={2}
              maxCount={1}
            />
          </div>
        </div>
      </div>
    );
  };

  /* =========================================================
  Textarea
========================================================= */

  const FormTextarea = ({
    label,
    name,
    formik,
    placeholder,
    required: isRequired = false,
  }) => {
    const error =
      formik.touched[name] && formik.errors[name] ? formik.errors[name] : "";

    return (
      <div className="grid gap-2 col-span-2">
        <Label htmlFor={name}>
          <CustomLabelText
            required={isRequired}
            labelText={label}
            errorField={error}
          />
        </Label>
        <Textarea
          id={name}
          name={name}
          placeholder={placeholder}
          value={formik.values[name]}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          autoComplete="off"
          onKeyPress={(e) => {
            e.which === 13 && e.preventDefault();
          }}
          className={error && `focus-visible:ring-red-500 border-red-500`}
        />
      </div>
    );
  };

  /* =========================================================
  DateInputPicker
========================================================= */

  const FormDateInputPicker = ({
    label,
    name,
    formik,
    placeholder,
    required: isRequired = false,
  }) => {
    const error =
      formik.touched[name] && formik.errors[name] ? formik.errors[name] : "";

    return (
      <div className="grid gap-2">
        <div className="min-w-0">
          <Label htmlFor={name}>
            <CustomLabelText
              required={isRequired}
              labelText={label}
              errorField={error}
            />
          </Label>
          <div className="relative mt-2">
            <DateInputPicker
              date={formik.values[name] ? formik.values[name] : ""}
              onSelect={(e) => {
                formik.setFieldValue(name, e);
              }}
              inputClassName="w-full"
              className={""}
              disabledDate={{ after: new Date() }}
            />
          </div>
        </div>
      </div>
    );
  };

  /* =========================================================
  Section Header
========================================================= */

  const SectionHeader = ({ title, description, icon }) => {
    return (
      <div className="md:col-span-2 flex items-start gap-3 py-2">
        {icon && <div className="mt-0.5 text-primary">{icon}</div>}

        <div>
          <h3 className="text-sm font-semibold">{title}</h3>

          {description && (
            <p className="mt-1 text-xs text-muted-foreground">{description}</p>
          )}
        </div>
      </div>
    );
  };

  /* =========================================================
  SMR
========================================================= */

  const SMRFields = ({ formik }) => {
    return (
      <>
        <SectionHeader
          title="SMR — Suspicious Matter Report"
          description="Capture the subject, suspicious activity and grounds for suspicion."
          icon={<AlertCircle className="h-5 w-5" />}
        />

        <Separator className="md:col-span-2" />

        <FormSelect
          label="Suspicion Type"
          name="suspicion_type"
          formik={formik}
          required
          options={suspicionTypeOptions}
        />

        <FormSelect
          label="AML/CTF Indicator"
          name="aml_ctf_indicator"
          formik={formik}
          required
          options={amlctfIndictorOptions}
        />

        <FormDateInputPicker
          label="Activity Date From"
          name="activity_date_from"
          formik={formik}
          type="date"
          required
        />

        <FormDateInputPicker
          label="Activity Date To"
          name="activity_date_to"
          formik={formik}
          type="date"
        />

        <FormField
          label="Amount"
          name="smr_amount"
          formik={formik}
          type="number"
          placeholder="0.00"
        />

        <FormSelect
          label="Currency"
          name="smr_currency"
          formik={formik}
          options={currencyListing}
          loading={countryLoading}
          placeholder="AUS"
          required
        />

        <FormMultiSelect
          label="Countries Involved"
          name="countries_involved"
          formik={formik}
          options={countryListing}
          loading={countryLoading}
          placeholder="Select Countries"
        />

        {/* <FormField
          label="Counterparties"
          name="counterparties"
          formik={formik}
          placeholder="Names / entities involved"
        /> */}

        <FormField
          label="Previous SMR Reference"
          name="previous_smr_reference"
          formik={formik}
          placeholder="AUSTRAC reference"
        />

        <FormTextarea
          label="Grounds for Suspicion"
          name="grounds_for_suspicion"
          formik={formik}
          required
          placeholder="Explain what happened, why it is unusual and why the information gives rise to suspicion..."
        />

        <FormTextarea
          label="Investigation Summary"
          name="investigation_summary"
          formik={formik}
          required
          placeholder="Summarise the investigation and key findings..."
        />

        <FormTextarea
          label="Customer Explanation"
          name="customer_explanation"
          formik={formik}
          placeholder="Record any explanation provided by the customer..."
        />
      </>
    );
  };

  /* =========================================================
  TTR
========================================================= */

  const TTRFields = ({ formik }) => {
    return (
      <>
        <SectionHeader
          title="TTR — Threshold Transaction Report"
          description="Capture the qualifying physical currency transaction."
          icon={<Landmark className="h-5 w-5" />}
        />

        <Separator className="md:col-span-2" />

        <FormField
          label="Other Parties / Roles"
          name="transactor_name"
          formik={formik}
          placeholder="Person conducting transaction"
        />

        <FormField
          label="Parties ID"
          name="transactor_id"
          formik={formik}
          placeholder="Identification number"
        />

        <FormDateInputPicker
          label="Transaction Date"
          name="transaction_date"
          formik={formik}
          type="datetime-local"
          required
        />

        <FormField
          label="Cash Amount"
          name="amount"
          formik={formik}
          type="number"
          placeholder="0.00"
          required
        />

        <FormSelect
          label="Currency"
          name="currency"
          formik={formik}
          placeholder="AUS"
          options={currencyListing}
          loading={countryLoading}
          required
        />

        <FormField
          label="AUD Equivalent"
          name="aud_equivalent"
          formik={formik}
          type="number"
          placeholder="0.00"
          required
        />

        <FormSelect
          label="Transaction Type"
          name="transaction_type"
          formik={formik}
          required
          options={incidentTransactionType}
        />

        <FormField
          label="Product / Service"
          name="product_service"
          formik={formik}
          placeholder="Product or service"
        />

        <FormField
          label="Account Number"
          name="account_number"
          formik={formik}
          placeholder="Account number"
        />

        <FormField
          label="Branch / Location"
          name="branch_location"
          formik={formik}
          placeholder="Branch / location"
        />

        <FormTextarea
          label="Transaction Purpose"
          name="transaction_purpose"
          formik={formik}
          placeholder="Purpose of transaction..."
        />
      </>
    );
  };

  /* =========================================================
  IFTI
========================================================= */

  const IFTIFields = ({ formik }) => {
    return (
      <>
        <SectionHeader
          title="IFTI — International Funds Transfer Instruction"
          description="Capture ordering party, beneficiary and international transfer information."
          icon={<Globe className="h-5 w-5" />}
        />

        <Separator className="md:col-span-2" />

        <FormField
          label="Ordering Party"
          name="ordering_party_name"
          formik={formik}
          required
          placeholder="Ordering party"
        />

        <FormField
          label="Ordering Account"
          name="ordering_party_account"
          formik={formik}
          placeholder="Account / identifier"
        />

        <FormField
          label="Beneficiary"
          name="beneficiary_name"
          formik={formik}
          required
          placeholder="Beneficiary"
        />

        <FormField
          label="Beneficiary Account"
          name="beneficiary_account"
          formik={formik}
          placeholder="Account / identifier"
        />

        <FormDateInputPicker
          label="Transfer Date"
          name="transfer_date"
          formik={formik}
          type="datetime-local"
          required
        />

        <FormField
          label="Amount"
          name="amount"
          formik={formik}
          type="number"
          placeholder="0.00"
          required
        />

        <FormSelect
          label="Currency"
          name="currency"
          formik={formik}
          placeholder="AUS"
          options={currencyListing}
          loading={countryLoading}
          required
        />

        <FormField
          label="AUD Equivalent"
          name="aud_equivalent"
          formik={formik}
          type="number"
          placeholder="0.00"
          required
        />

        <FormSelect
          label="Origin Country"
          name="origin_country"
          formik={formik}
          required
          options={countryListing}
          loading={countryLoading}
          placeholder="Country"
        />

        <FormSelect
          label="Destination Country"
          name="destination_country"
          formik={formik}
          required
          options={countryListing}
          loading={countryLoading}
          placeholder="Country"
        />

        <FormField
          label="Sending Institution"
          name="sending_institution"
          formik={formik}
          required
          placeholder="Financial institution"
        />

        <FormField
          label="Receiving Institution"
          name="receiving_institution"
          formik={formik}
          required
          placeholder="Financial institution"
        />

        <FormField
          label="Intermediary Institution"
          name="intermediary_institution"
          formik={formik}
          placeholder="Optional intermediary"
        />

        <FormSelect
          label="Payment Method"
          name="payment_method"
          formik={formik}
          required
          options={incidentPaymentMethodOptions}
        />

        <FormField
          label="Payment Reference"
          name="payment_reference"
          formik={formik}
          placeholder="Payment reference"
        />
      </>
    );
  };

  /* =========================================================
  CBM
========================================================= */

  const CBMFields = ({ formik }) => {
    return (
      <>
        <SectionHeader
          title="CBM — Cross-Border Movement"
          description="Capture person, movement and currency / BNI details."
          icon={<Globe className="h-5 w-5" />}
        />

        <Separator className="md:col-span-2" />

        <FormSelect
          label="Movement Type"
          name="movement_type"
          formik={formik}
          required
          options={incidentMovementTypeOptions}
        />

        <FormDateInputPicker
          label="Movement Date"
          name="movement_date"
          formik={formik}
          type="datetime-local"
          required
        />

        <FormField
          label="Border / Port"
          name="border_port"
          formik={formik}
          required
          placeholder="Airport / port / border"
        />

        <FormSelect
          label="Origin Country"
          name="origin_country"
          formik={formik}
          required
          options={countryListing}
          loading={countryLoading}
          placeholder="Country"
        />

        <FormSelect
          label="Destination Country"
          name="destination_country"
          formik={formik}
          required
          options={countryListing}
          loading={countryLoading}
          placeholder="Country"
        />

        <FormField
          label="Amount"
          name="amount"
          formik={formik}
          type="number"
          placeholder="0.00"
          required
        />

        <FormSelect
          label="Currency"
          name="currency"
          formik={formik}
          placeholder="AUS"
          options={currencyListing}
          loading={countryLoading}
          required
        />

        <FormField
          label="AUD Equivalent"
          name="aud_equivalent"
          formik={formik}
          type="number"
          placeholder="0.00"
          required
        />

        <FormSelect
          label="Bearer Negotiable Instrument"
          name="bni_indicator"
          formik={formik}
          required
          options={bniIndicatorOptions}
        />

        {formik.values.bni_indicator == "1" && (
          <>
            <FormSelect
              label="BNI Type"
              name="bni_type"
              formik={formik}
              placeholder="Instrument type"
              options={bniTypeOptions}
            />

            <FormField
              label="BNI Number / Reference"
              name="bni_number"
              formik={formik}
              placeholder="Instrument number"
            />

            <FormField
              label="BNI Issuer"
              name="bni_issuer"
              formik={formik}
              placeholder="Issuer"
            />

            <FormField
              label="BNI Value"
              name="bni_value"
              formik={formik}
              type="number"
              placeholder="0.00"
            />

            <FormSelect
              label="BNI Currency"
              name="bni_currency"
              formik={formik}
              placeholder="AUS"
              options={currencyListing}
              loading={countryLoading}
            />
          </>
        )}

        <FormField
          label="Owner of Funds"
          name="funds_owner"
          formik={formik}
          placeholder="Person/entity owning funds"
        />

        <FormTextarea
          label="Purpose of Funds"
          name="funds_purpose"
          formik={formik}
          placeholder="Purpose / reason for movement..."
        />
      </>
    );
  };

  return (
    <Formik
      initialValues={incidentData}
      enableReinitialize
      onSubmit={handleFormSubmit}
      validateOnBlur={true}
      validateOnChange={true}
      validate={(values) => {
        const schema = getValidationSchema(values);

        try {
          schema.validateSync(values, {
            abortEarly: false,
          });

          return {};
        } catch (error) {
          if (error instanceof Yup.ValidationError) {
            return error.inner.reduce((errors, currentError) => {
              if (currentError.path && !errors[currentError.path]) {
                errors[currentError.path] = currentError.message;
              }

              return errors;
            }, {});
          }

          return {};
        }
      }}
    >
      {(formik) => (
        <>
          {loading && <Spin expand={true} />}
          <form
            onSubmit={formik.handleSubmit}
            noValidate
            className="entry-section md:m-0 m-5"
          >
            <div className="form-box overflow-hidden overflow-y-auto max-h-[80vh] p-4 border rounded-lg">
              <div className="grid md:grid-cols-3 gap-4 mb-4">
                <div className="grid gap-2">
                  <div className="min-w-0">
                    <Label htmlFor="incident_type">
                      <CustomLabelText
                        required={true}
                        labelText="Incident Type"
                        errorField={formik.errors?.incident_type}
                        bottomAlign={true}
                      />
                    </Label>
                    <div className="relative mt-2">
                      <SearchSelect
                        frameworks={incidentTypeOptions?.filter(
                          (item) => item.value !== "",
                        )}
                        optionType={"Incident Type"}
                        handleSelect={(e) => {
                          formik.setFieldValue("incident_type", e);
                        }}
                        handleBlur={formik.handleBlur}
                        className={
                          formik.errors?.incident_type &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                        disabled={false}
                        initialValue={formik.values?.incident_type}
                      />
                    </div>
                  </div>
                </div>
                <div className="grid gap-2">
                  <div className="min-w-0">
                    <Label htmlFor="trust_id">
                      <CustomLabelText
                        required={false}
                        labelText="Trust"
                        errorField={formik.errors?.trust_id}
                        bottomAlign={true}
                      />
                    </Label>
                    <div className="relative mt-2">
                      <TrustSelect
                        orgId={organizationData?.organizationId}
                        frameworkData={trustListing} // List of vendors
                        optionType="Trust"
                        handleBlur={formik.handleBlur}
                        handleSelect={(e) => {
                          formik.setFieldValue("trust_id", e);
                          formik.setFieldValue("contactable_id", "");
                          formik.setFieldValue("contactable_type", "");

                          setVendorListing([]);
                          setVendorList([]);

                          setContactList([]);
                          setContactListing([]);
                        }}
                        name="trust_id"
                        disabled={
                          organizationData?.organizationId ? false : true
                        }
                        initialValue={
                          formik.values?.trust_id ? formik.values?.trust_id : ""
                        }
                        setTrustList={setTrustList} // Update vendor list as new data loads
                        setTrustLoading={setTrustLoading} // Control loading state
                        onClear={() => {
                          formik.setFieldValue("trust_id", "");
                          formik.setFieldValue("contactable_id", "");
                          formik.setFieldValue("contactable_type", "");

                          setVendorListing([]);
                          setVendorList([]);

                          setContactList([]);
                          setContactListing([]);
                        }}
                        loading={trustLoading}
                      />
                      {trustLoading && (
                        <span className="absolute top-2 right-2 animate-spin">
                          <Loader2 width={20} height={20} />
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="grid gap-2">
                  <Label htmlFor="contactable_type">
                    <CustomLabelText
                      required={true}
                      labelText="Contact Type"
                      errorField={formik.errors?.contactable_type}
                      bottomAlign={true}
                    />
                  </Label>
                  <div className="relative">
                    <SearchSelect
                      frameworks={contactTypeOption}
                      optionType={"Contact Type"}
                      handleSelect={(e) => {
                        formik.setFieldValue("contactable_type", e);
                        formik.setFieldValue("contactable_id", "");
                        setTimeout(() => {
                          formik.setTouched({ contactable_type: true });
                          formik.validateField("contactable_type");
                        }, 0);

                        setTimeout(() => {
                          formik.setTouched({ contactable_id: true });
                          formik.validateField("contactable_id");
                        }, 0);
                      }}
                      handleBlur={formik.handleBlur}
                      className={
                        formik.errors?.contactable_type &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                      disabled={false}
                      initialValue={formik.values?.contactable_type}
                    />
                  </div>
                </div>

                {formik.values?.contactable_type === 1 ? (
                  <>
                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="contactable_id">
                          <CustomLabelText
                            labelText={getModuleNamingBySlug(
                              organizationData?.organizationData,
                              "vendors",
                              "Vendor",
                            )}
                            errorField={formik.errors?.contactable_id}
                            required={true}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <VendorSelect
                            organizationId={
                              organizationData?.organizationId
                                ? organizationData?.organizationId
                                : ""
                            }
                            trustId={
                              formik.values?.trust_id
                                ? formik.values?.trust_id
                                : ""
                            }
                            amlctfContact={
                              formik.values?.trust_id ? false : true
                            }
                            kycOnly={formik.values?.trust_id ? false : true}
                            frameworkData={vendorListing} // List of vendors
                            optionType={getModuleNamingBySlug(
                              organizationData?.organizationData,
                              "vendors",
                              "Vendor",
                            )}
                            handleSelect={(e) => {
                              formik.setFieldValue("contactable_id", e);
                            }}
                            name="contactable_id"
                            disabled={false}
                            initialValue={
                              formik.values?.contactable_id
                                ? formik.values?.contactable_id
                                : ""
                            }
                            setVendorList={setVendorList} // Update vendor list as new data loads
                            setVendorLoading={setVendorLoading} // Control loading state
                            onClear={() => {
                              formik.setFieldValue("contactable_id", "");
                            }}
                            loading={vendorLoading}
                            className={
                              formik.errors?.contactable_id &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                          />
                          {vendorLoading && (
                            <span className="absolute top-2 right-2 animate-spin">
                              <Loader2 width={20} height={20} />
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    {formik.values?.contactable_id &&
                      formik.values?.trust_id && (
                        <>
                          <div className="grid gap-2">
                            <div className="min-w-0">
                              <Label htmlFor="sub_asset_id">
                                <CustomLabelText
                                  required={false}
                                  labelText={getModuleNamingBySlug(
                                    organizationData?.organizationData,
                                    "sub-assets",
                                    "Sub Asset",
                                  )}
                                  errorField={formik.errors?.sub_asset_id}
                                />
                              </Label>
                              <div className="relative mt-2">
                                <SubAssetSelect
                                  trustId={formik.values?.trust_id}
                                  frameworkData={
                                    subAssetListing ? subAssetListing : []
                                  } // List of vendors
                                  optionType={getModuleNamingBySlug(
                                    organizationData?.organizationData,
                                    "sub-assets",
                                    "Sub Asset",
                                  )}
                                  assetId={""}
                                  vendorId={
                                    formik?.values?.contactable_type === 1
                                      ? formik?.values?.contactable_id
                                        ? formik?.values?.contactable_id
                                        : ""
                                      : ""
                                  }
                                  handleSelect={(e) => {
                                    let subAssetData = subAssetListing?.find(
                                      (item) => item.value === e,
                                    );
                                    formik.setFieldValue("sub_asset_id", e);
                                    formik.setFieldValue(
                                      "asset_id",
                                      subAssetData?.asset_id,
                                    );
                                  }}
                                  name="sub_asset_id"
                                  disabled={
                                    !formik.values?.contactable_id ||
                                    subAssetLoading
                                  }
                                  initialValue={
                                    formik.values?.sub_asset_id
                                      ? formik.values?.sub_asset_id
                                      : ""
                                  }
                                  setSubAssetList={setSubAssetList}
                                  setSubAssetLoading={setSubAssetLoading} // Control loading state
                                  onClear={() => {
                                    formik.setFieldValue(`sub_asset_id`, "");
                                    formik.setFieldValue("asset_id", "");
                                  }}
                                  className={
                                    formik.errors?.sub_asset_id &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                  loading={subAssetLoading}
                                />
                                {subAssetLoading && (
                                  <span className="absolute top-2 right-2 animate-spin">
                                    <Loader2 width={20} height={20} />
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="grid gap-2">
                            <div className="min-w-0">
                              <Label htmlFor="asset_id">
                                <CustomLabelText
                                  labelText={getModuleNamingBySlug(
                                    organizationData?.organizationData,
                                    "assets",
                                    "Asset",
                                  )}
                                  errorField={formik.errors?.asset_id}
                                  required={false}
                                />
                              </Label>
                              <div className="mt-2 relative">
                                <AssetSelect
                                  trustId={formik.values?.trust_id}
                                  vendorId={
                                    formik.values?.contactable_id
                                      ? formik.values?.contactable_id
                                      : ""
                                  }
                                  frameworkData={
                                    assetListing ? assetListing : []
                                  }
                                  optionType={getModuleNamingBySlug(
                                    organizationData?.organizationData,
                                    "assets",
                                    "Asset",
                                  )}
                                  handleSelect={(e) => {
                                    formik.setFieldValue(`asset_id`, e);
                                    formik.setFieldValue(`sub_asset_id`, "");
                                  }}
                                  name="asset_id"
                                  // disabled={
                                  //   !formik.values?.contactable_id ||
                                  //   assetLoading ||
                                  //   subAssetLoading
                                  // }
                                  disabled={true}
                                  initialValue={
                                    formik.values?.asset_id
                                      ? formik.values?.asset_id
                                      : ""
                                  }
                                  setAssetList={setAssetList} // Update vendor list as new data loads
                                  setAssetLoading={setAssetLoading} // Control loading state
                                  onClear={() => {
                                    formik.setFieldValue(`asset_id`, "");
                                    formik.setFieldValue(`sub_asset_id`, "");
                                  }}
                                  className={
                                    formik.errors?.asset_id &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                  loading={assetLoading}
                                />
                                {assetLoading && (
                                  <span className="absolute top-2 right-2 animate-spin">
                                    <Loader2 width={20} height={20} />
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                  </>
                ) : formik.values?.contactable_type === 2 ? (
                  <div className="grid gap-2">
                    <div className="min-w-0">
                      <Label htmlFor="contactable_id">
                        <CustomLabelText
                          labelText={`${getModuleNamingBySlug(
                            organizationData?.organizationData,
                            "contacts",
                            "Customer",
                          )}`}
                          errorField={formik.errors?.contactable_id}
                          required={true}
                        />
                      </Label>
                      <div className="relative mt-2">
                        <ContactSelect
                          organizationId={
                            organizationData?.organizationId
                              ? organizationData?.organizationId
                              : ""
                          }
                          trustId={
                            formik.values?.trust_id
                              ? formik.values?.trust_id
                              : ""
                          }
                          amlctfContact={formik.values?.trust_id ? false : true}
                          kycOnly={formik.values?.trust_id ? false : true}
                          frameworkData={contactListing} // List of vendors
                          optionType={`${getModuleNamingBySlug(
                            organizationData?.organizationData,
                            "contacts",
                            "Customer",
                          )}`}
                          handleSelect={(e) => {
                            formik.setFieldValue(`contactable_id`, e);
                          }}
                          name="contactable_id"
                          disabled={false}
                          initialValue={
                            formik.values?.contactable_id
                              ? formik.values?.contactable_id
                              : ""
                          }
                          setContactList={setContactList} // Update vendor list as new data loads
                          setContactLoading={setContactLoading} // Control loading state
                          onClear={() => {
                            formik.setFieldValue(`contactable_id`, "");
                          }}
                          className={
                            formik.errors?.contactable_id &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                          loading={contactLoading}
                        />
                        {contactLoading && (
                          <span className="absolute top-2 right-2 animate-spin">
                            <Loader2 width={20} height={20} />
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                <div className="grid gap-2">
                  <div className="min-w-0">
                    <Label htmlFor="review_date">
                      <CustomLabelText
                        required={false}
                        labelText="Review Date"
                        errorField={formik.errors?.review_date}
                      />
                    </Label>
                    <div className="relative mt-2">
                      <DateInputPicker
                        date={
                          formik.values?.review_date
                            ? formik.values?.review_date
                            : ""
                        }
                        onSelect={(e) => {
                          formik.setFieldValue("review_date", e);
                        }}
                        inputClassName="w-full"
                        className={""}
                        disabledDate={{ after: new Date() }}
                      />
                    </div>
                  </div>
                </div>
                {/* Review By */}
                <div className="grid gap-2">
                  <div className="min-w-0">
                    <Label htmlFor="review_by_id">
                      <CustomLabelText
                        required={false}
                        labelText="Review By"
                        errorField={formik.errors?.review_by_id}
                      />
                    </Label>
                    <div className="relative mt-2">
                      <UserSelect
                        orgId={organizationData?.organizationId}
                        frameworkData={userListing} // List of vendors
                        optionType="User"
                        handleSelect={(e) => {
                          formik.setFieldValue(`review_by_id`, e);
                        }}
                        name="review_by_id"
                        disabled={false}
                        initialValue={
                          formik.values?.review_by_id
                            ? formik.values?.review_by_id
                            : ""
                        }
                        setUserList={setUserList}
                        setUserLoading={setUserLoading}
                        onClear={() => {
                          formik.setFieldValue(`review_by_id`, "");
                        }}
                        compliance={true}
                        senior_manager={true}
                        className={
                          formik.errors?.review_by_id &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                        loading={userLoading}
                      />
                      {userLoading && (
                        <span className="absolute top-2 right-2 animate-spin">
                          <Loader2 width={20} height={20} />
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="grid gap-2">
                  <div className="min-w-0">
                    <Label htmlFor="incident_date">
                      <CustomLabelText
                        required={true}
                        labelText="Incident Date"
                        errorField={formik.errors?.incident_date}
                      />
                    </Label>
                    <div className="relative mt-2">
                      <DateInputPicker
                        date={
                          formik.values?.incident_date
                            ? formik.values?.incident_date
                            : ""
                        }
                        onSelect={(e) => {
                          formik.setFieldValue("incident_date", e);
                        }}
                        inputClassName={
                          formik.errors?.incident_date
                            ? `focus-visible:ring-red-500 border-red-500 w-full`
                            : "w-full"
                        }
                        className={
                          formik.errors?.incident_date &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                        disabledDate={{ after: new Date() }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* ================================
                      Empty State
                  ================================= */}

              {!formik.values?.incident_type && (
                <div className="rounded-lg border border-dashed p-10 text-center">
                  <FileText className="mx-auto mb-3 h-10 w-10 text-muted-foreground" />

                  <h3 className="font-medium">Select an incident type</h3>

                  <p className="mt-1 text-sm text-muted-foreground">
                    Select SMR, TTR, IFTI or CBM to display the relevant
                    reporting fields.
                  </p>
                </div>
              )}

              {/* ================================
                      Dynamic Fields
                  ================================= */}

              {formik.values?.incident_type && (
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                  {formik.values?.incident_type === "0" && (
                    <SMRFields formik={formik} />
                  )}

                  {formik.values?.incident_type === "1" && (
                    <TTRFields formik={formik} />
                  )}

                  {formik.values?.incident_type === "2" && (
                    <IFTIFields formik={formik} />
                  )}

                  {formik.values?.incident_type === "3" && (
                    <CBMFields formik={formik} />
                  )}
                </div>
              )}

              <div className="grid gap-4 mt-4">
                <div className="grid gap-2">
                  <Label htmlFor="note">
                    <CustomLabelText
                      required={false}
                      labelText="Note for Austrac"
                      errorField={formik.errors?.note}
                    />
                  </Label>
                  <Textarea
                    id="note"
                    name="note"
                    value={formik.values?.note ? formik.values?.note : ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    autoComplete="off"
                    onKeyPress={(e) => {
                      e.which === 13 && e.preventDefault();
                    }}
                    className={
                      formik.errors?.note &&
                      `focus-visible:ring-red-500 border-red-500`
                    }
                  />
                </div>
                <div className="grid gap-2">
                  <Label htmlFor="files">
                    <CustomLabelText
                      required={false}
                      labelText="Documents"
                      errorField={formik.errors?.documents}
                    />
                  </Label>
                  <MultiFileUpload files={files} setFiles={setFiles} />
                </div>
              </div>
            </div>

            <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
              <Button type="submit" disabled={!formik.isValid}>
                Save
              </Button>
              <Button
                className="reset ml-3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  e.preventDefault();
                  toggleShowAddEditIncident();
                }}
                variant="secondary"
              >
                Cancel
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default AddEditIncident;
